import i18n from '@/i18n';

export const ALL_WEEKDAY_INDICES = [0, 1, 2, 3, 4, 5, 6];
export const WORKDAY_INDICES = [0, 1, 2, 3, 4];

export const ALL_WEEKDAY_LOWERCASE_ATTRIBUTES = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export function getWeekdayNamesForWeekdayIndices(weekdayIndices) {
  return weekdayIndices.map((weekdayIndex) =>
    i18n.t('weekdayByIndex_' + weekdayIndex)
  );
}

export function getAllWeekdayNames() {
  return getWeekdayNamesForWeekdayIndices(ALL_WEEKDAY_INDICES);
}

export function getAllWeekdayNameAbbreviations(maxLength = 2) {
  return getAllWeekdayNames().map((name) => name.slice(0, maxLength));
}

export function describeWeekdays(weekdays) {
  let copiedWeekdays = (weekdays || []).slice();
  copiedWeekdays.sort();

  // All
  if (JSON.stringify(copiedWeekdays) == JSON.stringify(ALL_WEEKDAY_INDICES)) {
    return i18n.t('daily');
  }

  // Condense ranges of at least 2+ days into more compact form. E.g. (de-DE):
  // 'Mo - Mi, Do - So'
  // 'Mo, Di, Mi - Fr, So'
  const ranges = [];
  let currentRange = [];

  for (const weekdayIndex of ALL_WEEKDAY_INDICES) {
    if (copiedWeekdays.includes(weekdayIndex)) {
      if (currentRange.length == 0) {
        currentRange.push(weekdayIndex);
      } else {
        const lastWeekdayIndex = currentRange[currentRange.length - 1];
        if (weekdayIndex == lastWeekdayIndex + 1) {
          currentRange.push(weekdayIndex);
        } else {
          ranges.push(currentRange.slice());
          currentRange = [weekdayIndex];
        }
      }
    }
  }
  ranges.push(currentRange.slice());

  let description = '';
  for (let r = 0; r < ranges.length; r++) {
    const range = ranges[r];
    const isLastRange = r == ranges.length - 1;

    if (range.length > 2) {
      const start = range[0];
      const end = range[range.length - 1];

      description +=
        i18n.t('weekdayByIndex_' + start).slice(0, 2) +
        ' - ' +
        i18n.t('weekdayByIndex_' + end).slice(0, 2);
    } else {
      for (let w = 0; w < range.length; w++) {
        const weekdayIndex = range[w];
        const isLast = w == range.length - 1;

        description += i18n.t('weekdayByIndex_' + weekdayIndex).slice(0, 2);
        if (!isLast) {
          description += ', ';
        }
      }
    }

    if (!isLastRange) {
      description += ', ';
    }
  }

  return description;
}

export function equalsDefaultWeekdays(weekdays) {
  const left = weekdays.slice().sort();
  const right = ALL_WEEKDAY_INDICES.slice().sort();
  return JSON.stringify(left) == JSON.stringify(right);
}

export default null;



// WEBPACK FOOTER //
// ./src/mixins/weekdays.js